import React from 'react';
export const RenderContext = React.createContext({});
export const useRenderContext = () => React.useContext(RenderContext);
export function hasRenderLink(context) {
    return context.renderLink !== null;
}
